var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductFile2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 12.7 12.7",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g836",
    transform: "matrix(0.12955511,0,0,0.12955511,0.08779751,-0.11920683)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M 66.333,6.875 H 25 v 12 h -8 v 74.25 h 58 v -12 h 8 V 19.375 Z M 66.771,9.702 79.167,19 H 66.695 Z M 73,79.125 v 1 1 10 H 19 v -70.25 h 6 1 1 29.776 L 56.68,33 H 73 Z M 58.695,31 58.77,21.702 71.167,31 Z M 81,79.125 H 75 V 31.375 L 58.333,18.875 H 27 v -10 H 64.776 L 64.68,21 H 81 Z",
    id: "path901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path898",
    className: "fil0",
    d: "M 25.875,39.844 H 26 27 45.875 v -2 H 27 26 25.875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path944",
    className: "fil0",
    d: "M 65.875,45.844 H 27 26 25.875 v 2 H 26 27 65.875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path892",
    className: "fil0",
    d: "M 65.875,53.844 H 27 26 25.875 v 2 H 26 27 65.875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path889",
    className: "fil0",
    d: "M 65.875,61.844 H 27 26 25.875 v 2 H 26 27 65.875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path886",
    className: "fil0",
    d: "M 65.875,69.844 H 27 26 25.875 v 2 H 26 27 65.875 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFile2);
export default __webpack_public_path__ + "static/media/product-file2.e6ed167672caa0abe1d1f5f051566942.svg";
export { ForwardRef as ReactComponent };